import React, { FC } from 'react';

import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import { useDispatch, useSelector } from 'src/store';
import { drawerWidth } from 'src/store/constant';
import { openDrawer } from 'src/store/slices/menu';

import { Header } from './Header';
import Sidebar from './Sidebar';

// assets

// ==============================|| MAIN LAYOUT ||============================== //

type MainLayoutProps = {
    children?: React.ReactNode;
};

const MainLayout: FC<MainLayoutProps> = ({ children }) => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    React.useEffect(() => {
        dispatch(openDrawer(!matchDownMd));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);

    return (
        <Box display="flex" alignItems="flex-start" justifyContent="flex-start">
            <Sidebar />
            <Box
                width="100%"
                paddingX="50px"
                paddingY="36px"
                display="flex"
                flexDirection="column"
                gap="24px"
                marginLeft={drawerOpen ? `${drawerWidth}px` : undefined}
                sx={{ overflow: 'hidden' }}
            >
                <Header />
                {children}
            </Box>
        </Box>
    );
};

export default MainLayout;
